<template>
  <div>
    <div class="container client-page-title">
      {{ $t("pages.Client.editTile") }}
    </div>

    <clientForm
      v-if="okParameters && client"
      :timeZones="timeZones"
      :cultures="cultures"
      :status="status"
      :rgpd="rgpd"
      :apiCurves="apiCurves"
      :availableServices="availableServices"
      :businessActs="businessActs"
      @save="updateClient"
      :client="client"
      :key="client.externalId"
      :pageFrom="'edit'"
      @goToList="goToList"
    />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import ClientService from "../../services/ClientService";
import clientForm from "../../forms/ClientForm";
import Swal from "sweetalert2";

export default defineComponent({
  name: "ClientEdit",
  inject: ["accessToken", "updatePageChangeState", "okToChangePage"],
  components: {
    clientForm,
  },
  watch: {
    currentScope(newVal) {
        if (newVal) {
          this.clientService = new ClientService(this.$jwt.token, newVal);
        }
      },
      accessToken(newVal) {
        if (newVal) {
          this.clientService = new ClientService(newVal, this.currentScope);
        }
      },
      "$i18n.locale": {
        handler() {
          this.businessActs = this.prepareBusinessActs(this.businessActs);
        }
      }
  },
  data() {
  return {
    timeZones: [],
    cultures: [],
    apiCurves: [],
    availableServices: [],
    businessActs: [],
    okParameters: false,
    status: null,
    rgpd: null,
  };
},
computed: {
  culture() {
    return this.$i18n.locale;
  }
},
created() {
  this.clientService = new ClientService(this.$jwt.token, this.$jwt.scope);
  this.currentScope = this.$jwt.scope;
  this.status = this.clientService.getStatus();
  this.rgpd = this.clientService.getRGPD();
}
,
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    var parameters = this.clientService
      .getParameters()
      .then((responseParams) => {
        this.apiCurves = responseParams.clientApiCurves;
        this.timeZones = responseParams.timezones;
        this.cultures = responseParams.clientCultures;
        this.availableServices = responseParams.clientServices;
        this.businessActs = this.prepareBusinessActs(responseParams.businessActs);
        this.okParameters = true;
      })
      .catch((error) => {
        console.log(error);
      });
    console.log(parameters);
  },

  methods: {
    prepareBusinessActs(businessActs) {
      if (Array.isArray(businessActs))
        return businessActs.map((ba) => { ba.display = this.$t(`businessActs.${ba.trKey}`); return ba; })
      let transformedBusinessActs = [];
      Object.keys(businessActs).forEach((k) => {
        const item = {
          trKey: k,
          businessAct: businessActs[k],
          display: this.$t(`businessActs.${k}`),
        }
        transformedBusinessActs.push(item);
      });
      return transformedBusinessActs;
    },
    updateClient: function (client) {
      // Afficher le message Sweetalert pendant la mise u00e0 jour
      const loadingSwal = Swal.fire({
        title: this.$t("pages.Client.updatingClient"),
        text: this.$t("pages.Client.pleaseWait"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      
      // Optimiser les donnu00e9es envoyu00e9es pour u00e9viter l'erreur 413 Payload Too Large
      const optimizedClient = this.optimizeClientData(client);
      
      this.clientService
        .update(optimizedClient)
        .then((response) => {
          // Fermer le message Sweetalert
          loadingSwal.close();
          
          if (response) {
            // Afficher un message de succès
            Swal.fire({
              icon: 'success',
              title: this.$t("pages.Client.updateSuccess"),
              text: this.$t("pages.Client.clientUpdatedSuccessfully"),
              timer: 2000,
              showConfirmButton: false
                     }).then(() => {
              // Rafraîchir la page après le message de succès
              window.location.reload();
            });
            
            this.okToChangePage.forceOk();
            this.updatePageChangeState(this.okToChangePage);
            this.$emit("clientUpdated", client);
          }
        })
        .catch((error) => {
          // Fermer le message Sweetalert et afficher une erreur
          loadingSwal.close();
          
          Swal.fire({
            icon: 'error',
            title: this.$t("pages.Client.updateError"),
            text: error.message || this.$t("pages.Client.errorOccurred"),
          });
          
          console.log(error);
        });
    },

    goToList: function () {
      this.$emit("closeEdit");
    },

    // Mu00e9thode pour optimiser les donnu00e9es du client avant l'envoi
    optimizeClientData: function(client) {
      // Cru00e9er une copie du client pour ne pas modifier l'original
      const optimizedClient = { ...client };
      
      // Convertir la configuration en chau00eene JSON si c'est un objet
      if (typeof optimizedClient.clientConfiguration === 'object') {
        optimizedClient.clientConfiguration = JSON.stringify(optimizedClient.clientConfiguration);
      }
      
      // Supprimer les donnu00e9es volumineuses qui ne sont pas nu00e9cessaires pour la mise u00e0 jour
      // ou qui peuvent u00eatre ru00e9cupu00e9ru00e9es autrement par le serveur
      if (optimizedClient.hierarchyContent && optimizedClient.hierarchyContent.length > 0) {
        // Si hierarchyContent est trop volumineux, ne garder que les informations essentielles
        optimizedClient.hierarchyContent = optimizedClient.hierarchyContent.map(item => ({
          id: item.id,
          levelsNumber: item.levelsNumber,
          // Garder d'autres champs essentiels selon votre logique mu00e9tier
        }));
      }
      
      // Supprimer les propriu00e9tu00e9s qui ne sont pas nu00e9cessaires pour la mise u00e0 jour
      delete optimizedClient._links;
      delete optimizedClient._embedded;
      
      // Si d'autres propriu00e9tu00e9s volumineuses existent, les traiter ici
      
      return optimizedClient;
    },
  },
});
</script>

<style scoped src="../../assets/css/client.css"></style>
